/* unplugin-vue-components disabled */import { render } from "./SurveyQuizQuestions.vue?vue&type=template&id=1da6ba79&scoped=true&ts=true"
import script from "./SurveyQuizQuestions.vue?vue&type=script&lang=ts"
export * from "./SurveyQuizQuestions.vue?vue&type=script&lang=ts"

import "./SurveyQuizQuestions.vue?vue&type=style&index=0&id=1da6ba79&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da6ba79"]])

export default __exports__